module.exports = __webpack_public_path__ + "img/cnucafeteria.1f11bc7b.png";